// extracted by mini-css-extract-plugin
export default {"supportButton":"xMM8xYSZMJ9q9Q7qZzYi","emoji":"yPc7VPq5zszRTi1Gomax","badge":"dnoD96vQhDJLhyT_iird"};